import React from 'react';


import AuthUserContext from './AuthUserContext';
import { firebase } from '../firebase';


const withAuthentication = (Component) => {
  class WithAuthentication extends React.Component {
      constructor(props) {
        super(props);

        this.state = {
          authUser: null,
        };
      }

      componentDidMount() {
        firebase.auth.onAuthStateChanged(authUser => {
          // console.log('onAuthStateChanged'+authUser);
          if(authUser){
            console.log("usuário logado");
            console.log(authUser);
            this.setState(() => ({ authUser: authUser }));
              console.log(this.state);
          }else{
            this.setState(() => ({ authUser: null }));
          }
        //   authUser
        //     ? this.setState(() => ({ authUser }))
        //     : this.setState(() => ({ authUser: null }));
        });
        firebase.auth.getRedirectResult().then(function(result) {
          if (result.credential) {
            console.log("getRedirectResult");
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            var token = result.credential.accessToken;
            console.log('token');
            console.log(token);
            // ...
          }
          // The signed-in user info.
          var user = result.user;
        }).catch(function(error) {
          console.log(error);
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // The email of the user's account used.
          var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential;
          // ...
        });
      }

    render() {
      const { authUser } = this.state;

      return (
        <AuthUserContext.Provider value={authUser}>
          <Component />
        </AuthUserContext.Provider>

      );
    }
  }

  return WithAuthentication;
}

export default withAuthentication;



// WEBPACK FOOTER //
// ./src/components/withAuthentication.js